// extracted by mini-css-extract-plugin
export default {"rolesList":"ProjectsRolesCardsList_rolesList__z4K0l","rolesListTitle":"ProjectsRolesCardsList_rolesListTitle__+Mpl6"};